var _module_exports = "<cdbl-loader ng-show=\"$ctrl.isLoading\"></cdbl-loader>\n<div ng-hide=\"$ctrl.isLoading\" ng-include=\"$ctrl.formTemplateUrl\"></div>";;
var path = '/workspace/src/app/components/settings/settings-notifications/settings-notifications.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;